import React, { useState } from "react";

const SubscribeForm = ({
    onClick,
    isSubscribed,
    chatbotIsOpen,
    subscribeUserHandler,
    props,
}) => {
    const [isLoading, setIsLoading] = useState(false);

    const subscribeHandler = async (e) => {
        e.preventDefault();
        const email_input = document.getElementById("subscribe-email");
        if (email_input.value == "") {
            email_input.focus();
            return false;
        }

        setIsLoading(true);
        await subscribeUserHandler(e);
        setIsLoading(false);
    };
    return (
        <React.Fragment>
            {!isSubscribed ? (
                <div
                    className={
                        "chatbot-chatbox-subscribe " +
                        (chatbotIsOpen ? "show" : "")
                    }
                >
                    <div className="chatbot-chatbox-subscribe-header">
                        <span
                            className="chatbot-chatbox-subscribe-header-close-toggle"
                            onClick={onClick}
                        >
                            <i className="fas fa-times"></i>
                        </span>
                        <div className="chatbot-chatbox-subscribe-header-logo">
                            <img
                                src={"/assets/img/logo_transparent.png"}
                                alt="logo"
                            />
                        </div>
                    </div>
                    <div className="chatbot-chatbox-subscribe-content">
                        <div className="greeting">
                            {props.subscribeWelcomeMessage}
                        </div>
                        <div>{props.subscribeSubWelcomeMessage}</div>
                        <form onSubmit={subscribeHandler}>
                            <div className="form-group">
                                <input
                                    id="subscribe-email"
                                    className="form-control email-input"
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                />
                                <span className="invalid-feedback d-none"></span>
                            </div>
                            <div className="text-center">
                                <button
                                    type="submit"
                                    className="btn btn-primary btn-lg text-center"
                                >
                                    {isLoading ? (
                                        <i className="fas fa-circle-notch fa-spin"></i>
                                    ) : (
                                        props.subscribeSubmitBtn
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            ) : null}
        </React.Fragment>
    );
};

export default SubscribeForm;
